import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import HomePageImg from 'svg/img/homepage-bottom-1-optimized.jpg';
import HomePageImgBlur from 'svg/img/homepage-bottom-1-blur.jpg';
import Container from 'common/Container';
import { Headline } from './components';

const PictureBottom = () => {
  const theme = useTheme();
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <Box
      position={'relative'}
      overflow={'hidden'}
      sx={{
        backgroundColor: theme.palette.grey[900],
      }}
    >
      <Box
        aria-hidden={'true'}
        position={'absolute'}
        top={0}
        right={0}
        bottom={0}
        left={0}
        sx={{
          backgroundImage: `url(${HomePageImgBlur})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(18px)',
          transform: 'scale(1.06)',
          opacity: isImageLoaded ? 0 : 1,
          transition: 'opacity 0.35s ease-out',
        }}
      />
      <Box
        component={'img'}
        src={HomePageImg}
        alt={''}
        aria-hidden={'true'}
        loading={'lazy'}
        decoding={'async'}
        onLoad={() => setIsImageLoaded(true)}
        position={'absolute'}
        top={0}
        right={0}
        bottom={0}
        left={0}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: isImageLoaded ? 1 : 0,
          transform: isImageLoaded ? 'scale(1)' : 'scale(1.02)',
          transition: 'opacity 0.45s ease-out, transform 0.6s ease-out',
        }}
      />
      <Box
        position={'absolute'}
        top={0}
        right={0}
        bottom={0}
        left={0}
        zIndex={1}
        sx={{
          background: theme.palette.common.black,
          opacity: 0.2,
        }}
      />
      <Container zIndex={2} position={'relative'}>
        <Container
          marginLeft={'0 !important'}
          maxWidth={{ md: '50% !important' }}
        >
          <Headline />
        </Container>
      </Container>
    </Box>
  );
};

export default PictureBottom;
